module.exports = __webpack_public_path__ + "img/appQRcodeB.c7872a92.jpeg";